module.exports = __webpack_public_path__ + "static/media/licenta34.72dd9d1f.png";